import template from './ResourceCardView.html';
import controller from './ResourceCardController';
import './ResourceCard.scss';
export const ResourceCardComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller,
    controllerAs: '$ctrl',
    template,
    bindings: {
        data: '<',
        onSave: '&?',
        onDelete: '&?',
    },
};
